import SVGIcon from "@assets/svg";
import { useNavigation } from "@react-navigation/native";
import { mobileSize, tabletSize, } from "@src/utils/screensize-helper";
import React, { useEffect, useState } from "react";
import { Text, Image } from "react-native";
import useStyles from "./styles.css";
import images from "@assets/images";

const UnawaProduct = ({ color, termsStyle }: any) => {
  const styles = useStyles();
  const isTablet = tabletSize();
  const isMobile = mobileSize();
  const navigation = useNavigation<any>();
  const [ currentYear , setCurrentYear ] = useState("");

  useEffect (() => {
    const year = new Date().getFullYear();
    setCurrentYear(
      year + ""
    );
  }, []);

  return (
    <Text style={[styles.unawaProductStyle, termsStyle, { color }]}>
      {/* {!isTablet && !isMobile ? <SVGIcon name="UnawaProduct"/> : <SVGIcon name="UnawaProductBlack"/>} {"\n"} */}
      <Image tintColor={'white'} style={{  width:100 , height: 25}} source={images.LogoUnawa} resizeMode="contain"/>
      {"\n"}
      <Text
        style={styles.copyRightBtnStyle}
        onPress={() => navigation.navigate("terms-condition")}
      >
        Terms & Conditions
      </Text>{"  "}
      |
      <Text
        style={styles.copyRightBtnStyle}
        onPress={() => navigation.navigate("privacy-policy")}
      >
        {"  "}
        Privacy Policy
      </Text>
      { "\n" +  "© " + currentYear + " UNAWA. All rights reserved." } {isMobile ? "\n" : ""}
    </Text>
  );
};

export default UnawaProduct;
